import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'attributeCategory',
    serviceName: 'shopadmin',
    query: gql`
      query attributeCategory(
        $ids: [String]
        $title: String
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        attributeCategory(
          ids: $ids
          title: $title
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          total
          last_page
          data {
            id
            title
          }
        }
      }
    `,
  },
  delete: {
    name: 'deleteAttributeCategory',
    serviceName: 'admin',
    query: gql`
      mutation deleteAttributeCategory($ids: [String]!) {
        deleteAttributeCategory(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'attributeCategory',
    serviceName: 'shopadmin',
    query: gql`
      query attributeCategory($ids: [String]) {
        attributeCategory(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'attributeCategory',
    serviceName: 'shopadmin',
    query: gql`
      query attributeCategory($ids: [String]) {
        attributeCategory(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
